import { render, staticRenderFns } from "./AppDataV.vue?vue&type=template&id=509b5509&scoped=true&"
import script from "./AppDataV.vue?vue&type=script&lang=js&"
export * from "./AppDataV.vue?vue&type=script&lang=js&"
import style0 from "./AppDataV.vue?vue&type=style&index=0&id=509b5509&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509b5509",
  null
  
)

export default component.exports